// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"9aa1df96","578":"dc29565b","707":"fe73eb57"}[chunkId] + ".chunk.css";
};